import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-061783ad"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("首页管理")
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "内容管理", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("文章发布")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("文章管理")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("分类管理")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("标签管理")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "人员管理", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("导师管理")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("研究生管理")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("后台管理")
const _hoisted_11 = { class: "toolbar" }
const _hoisted_12 = { class: "text" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("前台")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("退出登陆")

import { ref,onMounted,watch } from 'vue'
import { House, Document, DocumentAdd, DocumentChecked, Collection, 
CollectionTag, User, UserFilled, Avatar, Notification, ArrowDownBold  } from '@element-plus/icons-vue'
import Cookies from "js-cookie";
import { useRoute, useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const userName = ref('')
const active = ref('/admin/previewHome')
const router = useRouter()
const loginout = () => {
  Cookies.remove('cookie')
  router.push("/login")
}
const goto = () => {
  router.push("/");
}
watch(
  () => route.fullPath,
  (n, o) => {
    if(n.substring(0,6)==='/admin'){
      active.value = router.currentRoute.value.fullPath
    }
  }
)

onMounted(() => {
  userName.value = localStorage.getItem('userName')
  active.value = router.currentRoute.value.fullPath
})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_aside = _resolveComponent("el-aside")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, {
    class: "layout-container-demo",
    style: {"margin":"0px","padding":"0px"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_aside, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_scrollbar, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu, {
                "default-active": active.value,
                class: "el-menu-vertical-demo",
                "unique-opened": true,
                router: true,
                "background-color": "#f8f7f3",
                "text-color": "#335a7f"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, { index: "/admin/previewHome" }, {
                    title: _withCtx(() => [
                      _hoisted_1
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(House))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_sub_menu, { index: "/admin/postArticle" }, {
                    title: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Document))
                        ]),
                        _: 1
                      }),
                      _hoisted_2
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, { index: "/admin/postArticle" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(DocumentAdd))
                            ]),
                            _: 1
                          }),
                          _hoisted_3
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, { index: "/admin/article" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(DocumentChecked))
                            ]),
                            _: 1
                          }),
                          _hoisted_4
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, { index: "/admin/category" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Collection))
                            ]),
                            _: 1
                          }),
                          _hoisted_5
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, { index: "/admin/label" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(CollectionTag))
                            ]),
                            _: 1
                          }),
                          _hoisted_6
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_sub_menu, { index: "/admin/teacher" }, {
                    title: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(User))
                        ]),
                        _: 1
                      }),
                      _hoisted_7
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, { index: "/admin/teacher" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(UserFilled))
                            ]),
                            _: 1
                          }),
                          _hoisted_8
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_menu_item, { index: "/admin/postgraduate" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, null, {
                            default: _withCtx(() => [
                              _createVNode(_unref(Avatar))
                            ]),
                            _: 1
                          }),
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "/admin/user" }, {
                    title: _withCtx(() => [
                      _hoisted_10
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Notification))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["default-active"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_header, { style: {"text-align":"right","font-size":"12px","height":"50px"} }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", _hoisted_12, _toDisplayString(userName.value), 1),
                _createVNode(_component_el_dropdown, null, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_dropdown_item, { onClick: goto }, {
                          default: _withCtx(() => [
                            _hoisted_13
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_dropdown_item, { onClick: loginout }, {
                          default: _withCtx(() => [
                            _hoisted_14
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, { style: {"margin-right":"8px","margin-top":"1px","margin-left":"10px"} }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ArrowDownBold))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_el_main, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_scrollbar, null, {
                default: _withCtx(() => [
                  _createVNode(_component_router_view)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})